const STORAGE_KEY = "pending_referral_code";

export function captureReferralCode() {
  const code = new URLSearchParams(window.location.search).get("ref");
  if (code) {
    localStorage.setItem(STORAGE_KEY, code.toUpperCase());
    console.log("[referral] captured code from URL:", code.toUpperCase());
  }
}

export function peekReferralCode(): string | undefined {
  return localStorage.getItem(STORAGE_KEY) ?? undefined;
}

// Read the code for checkout without deleting it, it stays in localStorage
// until clearReferralCode() is called on the ?subscribed=true redirect.
// This means an abandoned checkout (back button, card declined) doesn't lose the code.
export function consumeReferralCode(): string | undefined {
  const code = localStorage.getItem(STORAGE_KEY) ?? undefined;
  if (code) {
    console.log("[referral] sending code to checkout:", code);
  } else {
    console.log("[referral] no code in localStorage at checkout time");
  }
  return code;
}

export function clearReferralCode() {
  const code = localStorage.getItem(STORAGE_KEY);
  if (code) {
    localStorage.removeItem(STORAGE_KEY);
    console.log("[referral] cleared code after successful subscription:", code);
  }
}
